import React from 'react';
import { BRAND_LOGO } from '../data/photos';
interface BrandLogoProps {
  /** 'light' = placed on a light surface, 'dark' = placed on the Midnight surface. */
  tone?: 'light' | 'dark';
  className?: string;
}

/**
 * The GC monogram.
 *
 * The supplied file has an opaque white background, so it is blended into the
 * surface instead of sitting in a white box:
 *  - on light surfaces, multiply drops the white and keeps the black mark
 *  - on Midnight, the mark is inverted to white and screen drops the (now black) box
 *
 * Swap in a transparent PNG or SVG and these blend modes can be removed.
 */
export function BrandLogo({
  tone = 'light',
  className = 'h-9 w-9'
}: BrandLogoProps) {
  if (!BRAND_LOGO) return null;
  return <img src={BRAND_LOGO} alt="" aria-hidden="true" loading="eager" decoding="async" className={`${className} shrink-0 object-contain ${tone === 'dark' ? 'mix-blend-screen invert' : 'mix-blend-multiply'}`} data-id="element-20" data-mp="23t8bx7wlzxxh" />;
}